import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";
import AuditLogs from "@/components/Addon/AuditLog/AuditLog";
import ApiMonitoring from "@/components/Addon/ApiMonitoring/ApiMonitoring";

const EmailVerifier = lazy(() => import("../components/Addon/Email-Verifier/EmailVerifier.jsx"));
const Calculator = lazy(() => import("../components/Addon/Calculator/Calculator"));
const SpamChecker = lazy(() => import("../components/Addon/Spam-Checker/Index"));
const RegisterCredentials = lazy(() => import("../components/RegisterCredentials/RegisterCredentials.jsx"));
const Sequencers = lazy(() => import("../components/Sequencers/Sequencers.jsx"));
const AdminSequencers = lazy(() => import("../components/Sequencers/AdminSequencers.jsx"));
const ParentCheckout = lazy(() => import("@/components/Addon/Prewarm/User/ParentCheckout"));
const Prewarm = lazy(() => import("@/components/Addon/Prewarm/ParentPrewarm"));
const PrewarmDetail = lazy(() => import("../components/Addon/Prewarm/Admin/PrewarmDetail.jsx"));
const PartnerWallet = lazy(() => import("../components/Addon/PartnerWallet/PartnerWallet.jsx"));
const ParentWallet = lazy(() => import("../components/Wallet/ParentWallet.jsx"));
const AdminWalletDetail = lazy(() => import("../components/Wallet/Admin/AdminWalletDetail.jsx"));
export default [
  { path: ROUTES.ADDONS.EMAIL_VERIFIER, element: <LazyRoute><EmailVerifier /></LazyRoute> },
  { path: ROUTES.ADDONS.CALCULATOR, element: <LazyRoute><Calculator /></LazyRoute> },
  { path: ROUTES.ADDONS.SPAM, element: <LazyRoute><SpamChecker /></LazyRoute> },
  { path: ROUTES.ADDONS.SEQUENCERS, element: <LazyRoute><Sequencers /></LazyRoute> },
  { path: ROUTES.ADDONS.ADMIN_SEQUENCERS, element: <LazyRoute><AdminSequencers /></LazyRoute> },
  { path: ROUTES.ADDONS.REGISTER_CREDENTIALS, element: <LazyRoute><RegisterCredentials /></LazyRoute> },
  { path: ROUTES.ADDONS.PREWARM, element: <LazyRoute><Prewarm /></LazyRoute> },
  { path: ROUTES.ADDONS.PREWARM_CHECKOUT, element: <LazyRoute><ParentCheckout /></LazyRoute> },
  { path: ROUTES.ADDONS.PREWARM_DETAIL, element: <LazyRoute><PrewarmDetail /></LazyRoute> },
  { path: ROUTES.ADDONS.WALLET, element: <LazyRoute><ParentWallet /></LazyRoute> },
  { path: ROUTES.ADDONS.WALLET_DETAIL, element: <LazyRoute><AdminWalletDetail /></LazyRoute> },
  { path: ROUTES.ADDONS.PARTNER_WALLET, element: <LazyRoute><PartnerWallet /></LazyRoute> },
  { path: ROUTES.ADDONS.AUDITLOG, element: <LazyRoute><AuditLogs /></LazyRoute> },
  { path: ROUTES.ADDONS.MONITORING, element: <LazyRoute><ApiMonitoring /></LazyRoute> },
];
